import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const managementTransfer = createCrudVuexModule({
  moduleName: "managementTransfer",
  namespaced: true,
  path: "/management/transfer",
  state: {
    sectors: [],
    paginationScanItems: undefined,
  },
  getters: {
    sectors: (state) => state.sectors,
    paginationScanItems: (state) => state.paginationScanItems,
  },
  mutations: {
    sectors: (state, value) => (state.sectors = value),
    paginationScanItems: (state, value) => (state.paginationScanItems = value),
  },
  actions: {
    async transferScan({ commit }, payload, clearStateBeforeRest = false) {
      try {
        if (clearStateBeforeRest) {
          commit("paginationScanItems", undefined);
        }
        const response = await rest.post("/management/transfer/scan", payload);
        commit("paginationScanItems", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async transfer({ commit }, payload) {
      const response = await rest.post("/management/transfer/library", payload);
      return response;
    },
  },
});
